// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3Qc9r","image":"VD6K0","podcast":"_27zG5"};